"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionManagerError = exports.BasePermissionsService = exports.PermissionActions = void 0;
/**
 * Expose constructors.
 */
__exportStar(require("./permission-manager"), exports);
var permission_actions_1 = require("./permission-actions");
Object.defineProperty(exports, "PermissionActions", { enumerable: true, get: function () { return permission_actions_1.PermissionActions; } });
__exportStar(require("./static-current-user-provider"), exports);
__exportStar(require("./i-hydrate-result"), exports);
var base_permissions_service_1 = require("./base-permissions-service");
Object.defineProperty(exports, "BasePermissionsService", { enumerable: true, get: function () { return base_permissions_service_1.BasePermissionsService; } });
var permission_manager_error_1 = require("./permission-manager-error");
Object.defineProperty(exports, "PermissionManagerError", { enumerable: true, get: function () { return permission_manager_error_1.PermissionManagerError; } });
